import { CUSTOMER_MAP } from '../AutoneTranslationContext.config';

export const customerIdIsInCustomerMap = (
  customerId: string,
): customerId is keyof typeof CUSTOMER_MAP => {
  return customerId in CUSTOMER_MAP;
};
